export default __webpack_public_path__ + "static/media/avatar2.457c089a.svg";